module.exports = __webpack_public_path__ + "assets/img/00023.976952cb.png";